<app-modal-wrapper [title]="'Select a playlist to add' | translate" (closeAction)="close()">
  <div modalBody>
    <ul class="list-group">
      <li *ngFor="let playlist of playlistList.content">
        <a href="javascript:void(0);" (click)="addSongToPlaylist(songId, playlist.id)" class="list-group-item list-group-item-action"
          >{{ playlist.title }}</a
        >
      </li>
    </ul>
  </div>
  <ng-container modalFooter>
    <button (click)="openCreatePlaylistDialog()" class="btn btn-primary m-2 rounded-pill">
      {{ 'feature.playlist.create' | translate }}
    </button>
  </ng-container>
</app-modal-wrapper>
